import NotificationsSettingsPage from "components/pages/NotificationsSettingsPage";

export default function CaptureNotifiLimSettings(props) {
    return <NotificationsSettingsPage /> 
}